module.exports = __webpack_public_path__ + "static/advanced-clock-d2a42e5f7e1f0699e1fe7cdfb7b1da98.png";